import { Res, WorkingPeriodStatusDTO } from 'core/api';
import { ValidationErrors } from 'core/infrastructure';

export function addClockIn(status: WorkingPeriodStatusDTO, now: Date): WorkingPeriodStatusDTO {
	return {
		...status,
		ClockIn: now,
	};
}

export function addClockOut(status: WorkingPeriodStatusDTO, now: Date): WorkingPeriodStatusDTO {
	return {
		...status,
		ClockOut: now,
	};
}

export function validateClockIn(data: WorkingPeriodStatusDTO): ValidationErrors {

	const errors: ValidationErrors = {};

	if (data.ClockOut !== null)
		throw new Error(Res.Msg.MSG_CANNOT_VALIDATE_CLOCKIN_WHEN_OUT());

	if (data.ClockIn === null)
		ValidationErrors.add(errors, 'ClockOut', Res.Msg.MSG_VALUE_REQUIRED());

	return errors;
}

export function validateClockOut(data: WorkingPeriodStatusDTO): ValidationErrors {

	const errors: ValidationErrors = {};

	if (data.ClockIn === null)
		throw new Error(Res.Msg.MSG_CANNOT_VALIDATE_CLOCKOUT_WITHOUT_IN());

	if (data.ClockOut === null) {
		ValidationErrors.add(errors, 'ClockOut', Res.Msg.MSG_VALUE_REQUIRED());
		return errors;
	}

	const clockOut = data.ClockOut;
	const clockIn = data.ClockIn;

	if (clockOut.getTime() < clockIn.getTime()) {
		ValidationErrors.add(errors, 'ClockOut', Res.Msg.MSG_CLOCK_OUT_DATE_NOT_VALID());
	}

	return errors;
}

export function canEditBusinessDay(status: WorkingPeriodStatusDTO): boolean {
	return status.ClockOut === null && status.CanChangeBusinessDay && status.User.CanModifyClockInDateTime;
}

export function canEditClockInDate(status: WorkingPeriodStatusDTO): boolean {
	return status.ClockOut === null && status.User.CanModifyClockInDateTime;
}

export function canEditClockOutDate(status: WorkingPeriodStatusDTO): boolean {
	return status.ClockIn !== null && status.User.CanModifyClockOutDateTime;
}